import { useLayoutEffect, useState } from "react";
import { Box, Button, Modal, Stack, TextField, Typography } from "@mui/material";
import MultiSelectSimple from "../../../../../../../../../../components/dinamicForm/multiSelectSimple";
import { ConfirmModal } from "../../../../../main/components";
import { useTranslation } from "react-i18next";
import { useReassingModal } from "./styles";
import { useReportFoliosDetailContext } from "../../../../hooks/useReportFoliosContext";
import { ObjectGeneric, onChangeEvent } from "../../../../../../../../../../utils/types/generals";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService"
import { useParams } from "react-router-dom";
import { handleAllErrors } from "../../../../../../../../../../utils/methods/handleErrors"
import { Types } from "../../../../../../../../../../utils/enums"

interface ReassignModalProps {
  open: boolean;
  onClose: () => void;
  refresh: () => void;
}

export const CancelFolioModal = ({ open, onClose, refresh }: ReassignModalProps) => {
  const { t } = useTranslation();
  const { id } = useParams()
  const styles = useReassingModal();
  const { items, callCancelEndpoints, setSnackbar } = useReportFoliosDetailContext();

  const [selectedReason, setSelectedReason] = useState<ObjectGeneric | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [comments, SetComments] = useState("");

  const isOtherReason = selectedReason?.value === 4;

  const handleReasonChange = (e: onChangeEvent) => {
    const reason = e.target.value;
    setSelectedReason(reason);

    if (reason?.value !== 4) {
      SetComments("");
    }
  }

  const handleSubmit = async () => {
    const body = {
      "reasonCancel": isOtherReason ? comments : selectedReason?.label,
    }

    const response = await reportFolioServices.cancelFolio({ body, id: id ?? "" })
    const code = response?.errors?.[0]?.code

    if (code) {
      setSnackbar({
        open: true,
        message: handleAllErrors(code, t, ''),
        type: Types.ERROR
      })
      return false;
    }

    setSnackbar({
      open: true,
      message: t('reportFolio.detail.cancel.message.edit'),
      type: Types.SUCCESS
    })
    setSelectedReason(null)
    SetComments("")
    return true;
  }

  useLayoutEffect(() => {
    callCancelEndpoints();
  }, []);

  return (
    <>
      <Modal open={open} /* onClose={onClose} */ aria-labelledby="reassign-modal">
        <Box sx={styles.container}>
          <Typography variant="h6" component="h2" textAlign="center">
            {t('reportFolio.detail.general.motiveCancelFolioTitle')}
          </Typography>

          <Typography variant="body2" textAlign="center">
            {t('reportFolio.detail.general.selectAndConfirm')}
          </Typography>

          <Stack spacing={2} sx={{ mt: 2 }}>
            <MultiSelectSimple
              isRequired
              errors={null}
              name="reason"
              label={t('general.tags.motive')}
              onChange={handleReasonChange}
              items={items.cancel}
              selected={selectedReason}
            />

            {isOtherReason && (
              <TextField
                fullWidth
                name="reason"
                value={comments}
                onChange={(e) => SetComments(e.target.value)}
                label="Descripción"
                variant="outlined"
                multiline
                rows={6}
                required
                InputProps={{
                  style: {
                    fontSize: '16px',
                    alignItems: 'flex-start',
                  },
                }}
                InputLabelProps={{
                  style: {
                    fontSize: '16px',
                  },
                }}
              />
            )}

            <Stack direction="row" spacing={2} justifyContent="space-between" mt={4}>
              <Button variant="text" color="primary" onClick={onClose}>
                {t('reportFolio.detail.general.cancel')}
              </Button>
              <Button
                variant="contained"
                onClick={() => setConfirmModalOpen(true)}
                disabled={!selectedReason}
                sx={styles.button}
              >
                {t('reportFolio.detail.general.cancelFolioConfirm')}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={async () => {
          const success = await handleSubmit();
          if (success) {
            refresh();
            onClose();
          }
        }}
        title="Confirmación"
        description={t('reportFolio.detail.general.cancelFolio')}
      />
    </>
  );
};